<template>
	<div class="content-box">
		<navBar title="投诉" color="#ffffff"></navBar>
		
		<span class="tips">请选择投诉该网页的原因:</span>
		 <div class="uni-flex uni-column">
		    <div class="flex-item flex-item-V" v-for="(item,index) in complaintList" :key="index" @click="complaintSun(item,index)"><span>{{item.text}}</span>
			<img src="../../../static/gray-arrow.png" mode="" alt="">
</div>
		</div>
		<popMask ref="popBottom" @getValue="getValue"></popMask>
		<successMask  ref="succMask"></successMask>
	</div>
</template>

<script>
import {Toast, MessageBox } from "mint-ui";
	import popMask from "./form.vue"
	import successMask from "./success.vue";
	import navBar from "../components/navbar.vue";
	export default {
		components:{
			popMask,
			successMask,
			navBar,
		},
		data(){
			return{
				feedbackType:3,//类型，问题反馈
				content:'',//投诉内容
				contact:'',//联系方式
				complaintList:[{text:'网页包含欺诈信息（如：假红包）'},
				{text:'网页包含违法信息'},
				{text:'网页可能包含谣言信息'},
				{text:'网页包含诱导分享/关注性质内容'},
				{text:'网页包含（虚假/抽奖性质/欺诈）拼团信息'},
				{text:'网页包含虚拟支付信息'},
				{text:'网页包含不适当的内容对我造成骚扰'},
				{text:'网页包含有偿投票信息'},
				{text:'网页包含隐私泄露风险'},
				{text:'其他'}
				],
				isEntranceData:'',
				messageType:'',
				clickMessId:0,
				channelRecordId:0,
				promotionCode:'',
				pageType:''
				
			}
		},
		mounted() {
			if(this.$route.query.isEntranceData){
				this.isEntranceData=this.$route.query.isEntranceData
			}
			this.pageType== this.$route.query.channelRecordId;
			var openid =  this.$base.getStorage('openid');
			var isWxAuthorized =  this.$base.getStorage('isWxAuthorized');
			        var city = this.$base.getStorage("city");
			if (!openid) { //静默登录手动登录
			} else if(isWxAuthorized==0&&city==1 &&openid&&!this.$store.state.userisSNS){
				 this.$base.setStorage('isSNS',true)
				this.$store.state.userisSNS=true;
				this.$commonApi.snsapiUserinfo();
				this.insertPageAccessData();
			}else{
				this.insertPageAccessData();
			}
			this.$commonApi.share();
		},
		methods:{
			insertPageAccessData() {
				var prevPage = "";
				if (this.pageType === "bookCity") {
					prevPage = "书城";
				} else if (this.pageType === "bookRecharge") {
					prevPage = "充值中心";
				}
				var params = {
					pageName: '投诉',
					pageRemark: '上级页面：'+prevPage,
					isEntranceData:this.isEntranceData
				}
				this.$api.insertPageAccessData(params).then(res => {
			
				})
			},
		
			complaintSun(item,index){
				if(index!=9){
					this.content=item.text;
					this.contact='';
					this.feedback();
				}else{
					this.$refs.popBottom.handleMask();
				}
			},
			getValue(obj){
				this.content=obj.content;
				this.contact=obj.contact;
				console.log(obj)
				if(!this.content){
					Toast({
						duration: 2000,
						message: "请输入投诉原因",
					})
					return false;
				}
				console.log(!(/^1[34578]\d{9}$/.test(this.contact)))
				if((!(/^1[34578]\d{9}$/.test(this.contact)) &&
				!(/^[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]@[a-zA-Z0-9][\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/.test(this.contact)))){
							Toast({
								duration: 2000,
								message: "请输入正确的联系方式",
							})
							return false;
						}
				this.feedback();
			},
			feedback() {
				console.log(this.$refs.succMask)
				var params = {
					content: this.content,
					contact: this.contact,
					imgUrl: '',
					feedbackType: this.feedbackType
				}
				this.$api.feedbackSubmit(params).then(res => {
					if (res.status == 1) {
						this.$refs.succMask.handleShow();
					} else {
						Toast({
							message: res.data.message,
						})
					}
				})
			
			}
			
		}
		
		}
</script>
<style scoped>
.content-box{
	background-color:  #EDEDED;
	height: 100%;
	/* overflow: hidden; */
}
	.uni-flex{
		background-color:  #ffffff;;
		padding:0px 14px;
	}
	.flex-item{
		border-bottom: 1px solid #F6F6F6;
		display: flex;
		justify-content: space-between;
		padding:15px 0px;
	}
	.flex-item>img{
		width: 7px;
		height:11px;
		    margin-top: 6px;
	}
	.flex-item>span{
		font-size: 15px;
		line-height: 21px;
		color: #000;
	}
	.tips{
		margin-left: 14px;
		font-size: 12.5px;
		color: #969696;
		padding-top: 14px;
		margin-bottom:4px;
		display: block;
		letter-spacing: 0.29px;
		margin-top:calc(44px + env(safe-area-inset-top));
	}

</style>



// WEBPACK FOOTER //
// src/view/bookComplaint/index.vue